import {Component, Input, ContentChild, AfterContentInit} from '@angular/core';
import {NgModel, FormControlName} from "@angular/forms";
import {NgClass, NgIf} from '@angular/common';
import {DeprecatedSharedUtilsModule} from '../deprecated-shared-utils-module';

@Component({
    selector: 'input-validation',
    templateUrl: './input.html',
    imports: [
        DeprecatedSharedUtilsModule
    ],
    styleUrls: ['./input.css']
})
export class InputComponent implements AfterContentInit {

   input: any;
   submittedInvalid: boolean;

   @Input() label: string;
   @Input() smallIcon: boolean;
   @Input() smallErrorText: boolean;
   @Input() isSelect: boolean;
   @Input() patternErrorMsg = '';
   @Input() groupString: string = '';

   @ContentChild(NgModel) model: NgModel;
   @ContentChild(FormControlName) control: FormControlName;

   constructor() {
   }

   ngAfterContentInit() {
      this.input = this.model || this.control;
   }

   hasEmpty(): boolean {
      return !this.input.value;
   }

   hasSuccess(): boolean {
      return this.input.valid && !this.hasEmpty();

   }

   hasError(): boolean {
      return this.input.invalid && !this.hasEmpty();
   }

   getError() {
      // REQUIRED
      if (this.input.hasError('required')) {
         return "Campo obrigatório";
      }
      // MINLENGTH
      else if (this.input.hasError('minlength')) {
         if (this.smallErrorText) {
            return "Minimo de " + this.input.errors.minlength.requiredLength + " caract.";
         } else {
            return "Informe um minimo de " + this.input.errors.minlength.requiredLength + " caracteres";
         }
      }
      // MAXNLENGTH
      else if (this.input.hasError('maxlength')) {
         if (this.smallErrorText) {
            return "Máximo de " + this.input.errors.maxlength.requiredLength + " caract.";
         } else {
            return "Informe um máximo de " + this.input.errors.maxlength.requiredLength + " caracteres";
         }
      }
      // TYPE: EMAIL
      else if (this.input.hasError('email')) {
         return "Informe um email válido";
      } else if (this.input.hasError('pattern')) {
         return this.patternErrorMsg;
      }else if(this.input.hasError('min')){
         return "O valor deve ser maior ou igual a " + this.input.errors.min.min;
      }else if(this.input.hasError('max')){
         return "O valor deve ser menor ou igual a " + this.input.errors.max.max;
      }

      return false;
   }

   markErrors() {
      this.submittedInvalid = true;
   }

   markOffErrors() {
      this.submittedInvalid = false;
   }

}
